
import { default as CommonUtils, default as commonUtils } from "@/common-utils";
import "swiper/css/swiper.css";
import { Component, Prop, Vue} from "vue-property-decorator";
import firebase from "firebase/app";
import axios from "axios";
import { BannerMasterVO } from "@/views/biz/main/vo/main.vo";
import AdLogs from "@/ad-logs";

@Component
export default class SignUp4 extends Vue {
  @Prop()
  rewardPoint!: string;
  @Prop()
  memId!: string;
  banners = [] as Array<BannerMasterVO>;

  async sendMarketingData(){
    // 페이스북 픽셀 장바구니 추가 태그
    AdLogs.sendMetaPixelEventLogs('CompleteRegistration', new Map());
    CommonUtils.sendCommonEventLogs(this, firebase.analytics.EventName.SIGN_UP, {method: ''});
    CommonUtils.sendMobionLogEvent({convType:'join'});
  }
  created() { 
    // 가입 중복데이터 제거
    if(this.memId && localStorage.getItem("memId") != this.memId){
      this.sendMarketingData();
      localStorage.setItem("memId",this.memId);
    }
    const params = {
      bannerTypeCd: '052004'
    };    
    // 배너 로드
    axios.get("/banners",{ params: params }).then((r) => {
      this.banners = r.data;
    });    
  
  }
}
